import { defineStore } from "pinia";
import { ref } from "vue";
import { useToast } from "vue-toastification";
import dataCollectionService from "@/services/dataCollection";

export const useDataCollectionStore = defineStore("dataCollection", () => {
  const toast = useToast();
  const loading = ref(false);

  async function fetchDataCollectionsGrid(companyId) {
    loading.value = true;
    try {
      const res = await dataCollectionService.getDataCollectionsGrid(companyId);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function fetchDataCollectionsSimple(companyId) {
    loading.value = true;
    try {
      const res = await dataCollectionService.getDataCollectionsSimple(companyId);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function fetchDataSourceById(payload) {
    loading.value = true;
    try {
      const res = await dataCollectionService.getDataSourceById(payload);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function addDataSource(payload) {
    loading.value = true;
    try {
      const res = await dataCollectionService.addDataSource(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function editDataSource(payload) {
    loading.value = true;
    try {
      const res = await dataCollectionService.editDataSource(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function deleteDataSource(payload) {
    loading.value = true;
    try {
      const res = await dataCollectionService.deleteDataSource(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function deleteDataCollectionUrl(payload) {
    loading.value = true;
    try {
      const res = await dataCollectionService.deleteDataCollectionUrl(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function vensafeDataCollection(payload) {
    loading.value = true;
    try {
      const res = await dataCollectionService.vensafeDataCollection(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  return {
    loading,
    fetchDataCollectionsGrid,
    fetchDataCollectionsSimple,
    fetchDataSourceById,
    addDataSource,
    editDataSource,
    deleteDataSource,
    deleteDataCollectionUrl,
    vensafeDataCollection,
  };
});
